import { Box, Flex } from '@chakra-ui/react';
import { Card, CardContent } from '@mesh.ai/rabbit';
import { L2_PATHS, L3_PATHS } from 'Deer/constants/routes';
import { DeerBreadcrumbs } from 'Deer/intent/components/Layout/Layout';
import { useSelectIsL2Visible } from 'Deer/slice/DeerNav.slice';
import { useHistory } from 'react-router-dom';

import { ArrowBack } from 'assets/assetsV1/iconComponents';

import { isNetchexLogin } from 'constants/netChexConstants';

import { Button } from 'uiToolkitV1/Button';
import { TextHeader2 } from 'uiToolkitV1/Typography';

const SURVEY_CREATION_BREADCRUMBS = {
  items: [
    { label: 'Company', to: L2_PATHS.company.overview },
    {
      label: 'Engagement',
      to: `${L3_PATHS.company.engagement.settings}?activeTabId=engagement_surveys`,
    },
  ],
  page: { label: 'Add new survey' },
};

export const SurveyCreationHeader = () => {
  const history = useHistory();
  const isL2NavVisible = useSelectIsL2Visible();

  const handleBackClick = () => {
    const route = `${L3_PATHS.company.engagement.settings}?activeTabId=engagement_surveys`;
    history.push(route);
  };

  return (
    <Box ml={isL2NavVisible ? '0' : '34px'}>
      {!isNetchexLogin && (
        <Box mb={2}>
          <DeerBreadcrumbs breadcrumbs={SURVEY_CREATION_BREADCRUMBS} />
        </Box>
      )}
      <Card style={{ marginBottom: '12px', padding: '12px 12px 12px 4px', borderRadius: '8px' }}>
        <Box w="100%">
          <CardContent style={{ width: '100%' }}>
            <Flex minH="40px" alignItems="center">
              <Button
                StartIcon={ArrowBack}
                variant="tertiary"
                iconSize="24px"
                onClick={handleBackClick}
                startIconProps={{ color: '#666 !important' }}
              />
              <TextHeader2 bold mr="12px">
                Add a new survey
              </TextHeader2>
            </Flex>
          </CardContent>
        </Box>
      </Card>
    </Box>
  );
};
